export function KpiCard({ icon: Icon, label, value, accent, testid }) {
  return (
    <div className="bg-white border border-navy-200 rounded-xl p-5 h-full" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="brand-label text-navy-400">{label}</span>
        {Icon && <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${accent ? "bg-brand text-white" : "bg-navy-100 text-navy-700"}`}><Icon size={18} /></div>}
      </div>
      <div className="mt-3 font-heading text-2xl sm:text-3xl font-extrabold text-navy-900">{value}</div>
    </div>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between flex-wrap gap-4 mb-6">
      <div>
        <h2 className="font-heading text-2xl font-bold text-navy-900 tracking-tight">{title}</h2>
        {subtitle && <p className="text-navy-500 mt-1 text-sm">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
